import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CloseIcon } from '../../../atoms/Icon';
var MobileMenuCloseButton = function MobileMenuCloseButton(_ref) {
  var onClick = _ref.onClick,
    mobileMenuCloseButtonLabel = _ref.mobileMenuCloseButtonLabel,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 'Lukk' : _ref$value;
  return /*#__PURE__*/React.createElement("button", {
    className: "menu__mobile-close-button",
    onClick: onClick,
    "aria-label": mobileMenuCloseButtonLabel ? mobileMenuCloseButtonLabel : 'Lukk'
  }, /*#__PURE__*/React.createElement("span", null, value), /*#__PURE__*/React.createElement(CloseIcon, {
    className: "menu__mobile-close-button-icon"
  }));
};
var MobileMenuHeaderItem = function MobileMenuHeaderItem(_ref2) {
  var index = _ref2.index,
    onHeaderItemSelected = _ref2.onHeaderItemSelected,
    menuLink = _ref2.menuLink,
    isActive = _ref2.isActive,
    LinkTemplate = _ref2.LinkTemplate;
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(e) {
      if (!isActive) {
        e.preventDefault();
      }
      onHeaderItemSelected(index);
    },
    tabIndex: "0",
    className: classnames('menu__mobile-heading-item', {
      'menu__mobile-heading-item--active': isActive
    })
  }, /*#__PURE__*/React.createElement(LinkTemplate, {
    className: "menu__mobile-heading-item-link",
    url: menuLink.heading.url
  }, /*#__PURE__*/React.createElement("span", {
    className: "menu__mobile-heading-item-text"
  }, menuLink.heading && menuLink.heading.text))));
};
var MobileMenuHeader = function MobileMenuHeader(_ref3) {
  var onMobileMenuToggle = _ref3.onMobileMenuToggle,
    menuLinks = _ref3.menuLinks,
    LinkTemplate = _ref3.LinkTemplate,
    selectedIndex = _ref3.selectedIndex,
    onHeaderItemSelected = _ref3.onHeaderItemSelected,
    mobileMenuCloseButtonLabel = _ref3.mobileMenuCloseButtonLabel,
    closeButtonValue = _ref3.closeButtonValue;
  return /*#__PURE__*/React.createElement("div", {
    className: "menu__mobile-header"
  }, menuLinks && /*#__PURE__*/React.createElement("ul", {
    className: "menu__mobile-heading-links"
  }, menuLinks.map(function (menuLink, index) {
    return /*#__PURE__*/React.createElement(MobileMenuHeaderItem, {
      key: menuLink.heading ? menuLink.heading.text : index,
      index: index,
      LinkTemplate: LinkTemplate,
      menuLink: menuLink,
      isActive: selectedIndex === index,
      onHeaderItemSelected: onHeaderItemSelected
    });
  })), /*#__PURE__*/React.createElement(MobileMenuCloseButton, {
    onClick: onMobileMenuToggle,
    mobileMenuCloseButtonLabel: mobileMenuCloseButtonLabel,
    value: closeButtonValue
  }));
};
MobileMenuHeader.propTypes = {
  LinkTemplate: PropTypes.func,
  onMobileMenuToggle: PropTypes.func,
  menuLinks: PropTypes.arrayOf(PropTypes.shape({
    heading: PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string
    }),
    links: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string
    }))
  })),
  mobileMenuCloseButtonLabel: PropTypes.string
};
export default MobileMenuHeader;